<template>
  <div class="page-content">
    <div class="row">
      <div class="col-sm-12">
        <agent-settings @update:selected-agent="selectedAgent = $event" />
        <agent-instructions :agent-name="selectedAgent" />
        <agent-examples :agent-name="selectedAgent" />
        <br>
        <generate-operator-call-summary />
        <br>
        <generate-operator-call-summary-scoring />
        <br>
        <generate-master-call-summary v-if="isTeamLeadOrAbove" />
        <br v-if="isTeamLeadOrAbove">
        <extract-call-motivation-and-objection />
        <br>
        <generate-call-avoidance-analysis />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineAsyncComponent, ref, computed, toRefs } from 'vue';
import util from '@/Utils/util';
import { useProfile } from '@/use/profile';

const AgentSettings = defineAsyncComponent(() => import('./AgentSettings.vue') as any);
const AgentInstructions = defineAsyncComponent(() => import('./AgentInstructions.vue') as any);
const AgentExamples = defineAsyncComponent(() => import('./AgentExamples.vue') as any);
const GenerateOperatorCallSummary = defineAsyncComponent(() => import('./GenerateOperatorCallSummary.vue') as any);
const GenerateOperatorCallSummaryScoring = defineAsyncComponent(() => import('./GenerateOperatorCallSummaryScoring.vue') as any);
const GenerateMasterCallSummary = defineAsyncComponent(() => import('./GenerateMasterCallSummary.vue') as any);
const ExtractCallMotivationAndObjection = defineAsyncComponent(() => import('./ExtractCallMotivationAndObjection.vue') as any);
const GenerateCallAvoidanceAnalysis = defineAsyncComponent(() => import('./GenerateCallAvoidanceAnalysis.vue') as any);

const { userRoles } = useProfile();
const { isAdmin, isSupervisor, isDirector, isTeamLead } = toRefs(userRoles);

const isTeamLeadOrAbove = computed(
  () => isAdmin.value || isSupervisor.value || isDirector.value || isTeamLead.value,
);

const selectedAgent = ref('');

util.moveToTop();
</script>
